/** @format */

import React from "react";
import { Spinner, Toast, ToastContainer } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getRandomUUID } from "../resources/ResourceFunctions";

type Props = {
  isLoading: boolean;
  text?: string;
};

const LoadingToast: React.FC<Props> = ({ isLoading, text }) => {
  const { t: _ } = useTranslation();

  return (
    <>
      {isLoading && (
        <ToastContainer
          className="position-fixed p-4"
          position="bottom-end"
          style={{ zIndex: 10 }}
        >
          <Toast className={`toast-info`} bg={"info"} id={getRandomUUID()} show>
            <Toast.Body className="d-flex align-items-center justify-content-between">
              {text ?? `${_("Loading")}...`}
              <Spinner />
            </Toast.Body>
          </Toast>
        </ToastContainer>
      )}
    </>
  );
};

export default LoadingToast;
